import React from "react";
export const inputCls = "w-full min-h-[52px] rounded-xl border border-line-strong bg-ink-3 px-4 text-[16px] text-fg placeholder:text-muted/80 transition-[border-color,box-shadow] duration-150 ease-out focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/30";
type FieldProps = {
  label: string;
  htmlFor: string;
  hint?: string;
  optional?: boolean;
  children: React.ReactNode;
  className?: string;
};
export function Field({
  label,
  htmlFor,
  hint,
  optional,
  children,
  className = ""
}: FieldProps) {
  return <div className={className} data-id="element-117" data-mp="xrdvap2cn43x">
      <label htmlFor={htmlFor} className="mb-2 flex items-baseline justify-between text-[15px] font-medium text-fg" data-id="element-118" data-mp="szvsdvgrmtgb">
        {label}
        {optional && <span className="text-sm font-normal text-muted" data-id="element-119" data-mp="nzzodw82j20r">Optional</span>}
      </label>
      {children}
      {hint && <p className="mt-2 text-sm text-muted" data-id="element-120" data-mp="1lhpxrkets8n4">{hint}</p>}
    </div>;
}